// Copyright (c) Ping. All rights reserved.

import type { MiniProfileActionKey, ProfilePresence } from './types';

export const profileStrings = {
  loading: 'Loading profile…',
  notFound: "Couldn't find that user",
  blocked: 'You blocked this person',
  error: 'Something went wrong',
  retry: 'Try again',
  bioFallback: 'No bio yet',
  presence: (presence: ProfilePresence): string => {
    switch (presence) {
      case 'online':
        return 'Online';
      case 'away':
        return 'Away';
      case 'offline':
        return 'Offline';
    }
  },
  mutualContacts: (n: number): string => (n === 1 ? '1 mutual contact' : `${n} mutual contacts`),
  action: (key: MiniProfileActionKey): string => {
    switch (key) {
      case 'message':
        return 'Message';
      case 'call':
        return 'Call';
      case 'viewProfile':
        return 'View profile';
      case 'more':
        return 'More';
    }
  },
  actionDisabledMessage: 'Messaging unavailable',
  actionDisabledCall: 'Calling unavailable',
  closeLabel: 'Close',
} as const;

export type ProfileStrings = typeof profileStrings;
